module.exports = __webpack_public_path__ + "static/nikita-6d7ba5abd2bb5b5e04de0182cb0a1bfe.png";